(function () {
  var PATHS = { home: '/', services: '/pages/services', reports: '/pages/custom-reports', about: '/pages/about', contact: '/pages/contact' };
  var docEl = document.documentElement;

  /* ---------- language ---------- */
  function setLang(l, save) {
    docEl.lang = l;
    try { if (save) localStorage.setItem('of-lang', l); } catch (e) {}
    var opts = document.querySelectorAll('option[data-' + l + ']');
    for (var i = 0; i < opts.length; i++) opts[i].textContent = opts[i].getAttribute('data-' + l);
  }
  var initialLang = 'fr';
  try { initialLang = new URLSearchParams(location.search).get('lang') || localStorage.getItem('of-lang') || 'fr'; } catch (e) {}
  setLang(initialLang === 'en' ? 'en' : 'fr', false);
  var lt = document.getElementById('lang-toggle');
  if (lt) lt.addEventListener('click', function () { setLang(docEl.lang === 'en' ? 'fr' : 'en', true); });

  /* ---------- pages ---------- */
  function show(id, push) {
    if (!document.getElementById(id)) id = 'home';
    var pages = document.querySelectorAll('.page');
    for (var i = 0; i < pages.length; i++) pages[i].classList.toggle('active', pages[i].id === id);
    var links = document.querySelectorAll('.nav-links a[data-page]');
    for (var j = 0; j < links.length; j++) links[j].classList.toggle('active', links[j].getAttribute('data-page') === id);
    if (push && history.pushState && location.pathname !== PATHS[id]) history.pushState({ page: id }, '', PATHS[id]);
    window.scrollTo(0, 0);
  }
  function fromPath() {
    var p = location.pathname.replace(/\/$/, '') || '/';
    for (var id in PATHS) if (PATHS[id] === p) return id;
    return 'home';
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-page]');
    if (!a) return;
    e.preventDefault();
    show(a.getAttribute('data-page'), true);
  });
  window.addEventListener('popstate', function () { show(fromPath(), false); });

  /* ---------- after a form was sent ---------- */
  var posted = /contact_posted=true/.test(location.search);
  var hash = location.hash;
  if (posted && hash === '#report_form') {
    show('reports', false);
    var rt = document.getElementById('report-thanks');
    if (rt) { rt.hidden = false; setTimeout(function () { rt.scrollIntoView({ block: 'center' }); }, 50); }
  } else if (posted || hash === '#contact_form') {
    show('contact', false);
    if (posted) {
      var ok = document.getElementById('contact-ok');
      var body = document.querySelector('#contact .form-body');
      if (ok) ok.hidden = false;
      if (body) body.hidden = true;
    }
  } else {
    show(fromPath(), false);
  }
  if (document.querySelector('#report_form .form-err, #report_form .errors')) show('reports', false);

  /* ---------- flipbook ---------- */
  var data = {};
  try { data = JSON.parse(document.getElementById('of-reports').textContent); } catch (e) {}
  var lb = document.getElementById('lb'), img = document.getElementById('lb-img'), count = document.getElementById('lb-count');
  var cur = [], idx = 0, lastFocus = null, curName = '';
  var lbCta = document.getElementById('lb-cta');
  function render() {
    img.src = cur[idx];
    count.textContent = (idx + 1) + ' / ' + cur.length;
    lbCta.hidden = idx !== cur.length - 1;
    if (cur[idx + 1]) { var pre = new Image(); pre.src = cur[idx + 1]; }
  }
  function openFlip(key) {
    var r = data[key]; if (!r || !r.slides.length) return;
    cur = r.slides; curName = r.name;
    idx = 0; lastFocus = document.activeElement; render();
    lb.hidden = false; document.body.style.overflow = 'hidden';
    document.getElementById('lb-next').focus();
  }
  function closeLb(el) { el.hidden = true; document.body.style.overflow = ''; if (lastFocus) lastFocus.focus(); }
  function step(d) { if (!cur.length) return; idx = (idx + d + cur.length) % cur.length; render(); }
  document.addEventListener('click', function (e) {
    var f = e.target.closest('[data-flip]');
    if (f) { e.preventDefault(); openFlip(f.getAttribute('data-flip')); }
  });
  document.getElementById('lb-prev').addEventListener('click', function () { step(-1); });
  document.getElementById('lb-next').addEventListener('click', function () { step(1); });
  document.getElementById('lb-close').addEventListener('click', function () { closeLb(lb); });
  lb.addEventListener('click', function (e) { if (e.target === lb) closeLb(lb); });
  var tx = null;
  lb.addEventListener('touchstart', function (e) { tx = e.touches[0].clientX; }, { passive: true });
  lb.addEventListener('touchend', function (e) { if (tx === null) return; var dx = e.changedTouches[0].clientX - tx; if (Math.abs(dx) > 40) step(dx < 0 ? 1 : -1); tx = null; });

  /* ---------- full report request ---------- */
  var rq = document.getElementById('rq');
  function openRequest(name, from) {
    document.getElementById('rq-name').value = name;
    document.getElementById('rq-title').textContent = name;
    lastFocus = from; rq.hidden = false; document.body.style.overflow = 'hidden';
    document.getElementById('rq-email').focus();
  }
  document.addEventListener('click', function (e) {
    var r = e.target.closest('[data-request]');
    if (!r) return;
    e.preventDefault();
    openRequest(r.getAttribute('data-request'), r);
  });
  document.getElementById('lb-req').addEventListener('click', function () {
    var from = lastFocus; lb.hidden = true; openRequest(curName, from);
  });
  document.getElementById('rq-close').addEventListener('click', function () { closeLb(rq); });
  rq.addEventListener('click', function (e) { if (e.target === rq) closeLb(rq); });

  document.addEventListener('keydown', function (e) {
    if (!lb.hidden) {
      if (e.key === 'ArrowRight') step(1);
      else if (e.key === 'ArrowLeft') step(-1);
      else if (e.key === 'Escape') closeLb(lb);
    } else if (!rq.hidden && e.key === 'Escape') closeLb(rq);
  });
})();
